import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import PlayersView from 'views/players'; // Importing PlayersView component
import FilterFlujoCajaResumido from 'views/partner/reports/flujoCajaResumido/filterFlujoCajaResumido'; // Importing filter component for cash flow summary
import TableFlujoCajaResumido from 'views/partner/reports/flujoCajaResumido/tableFlujoCajaResumido'; // Importing table component for cash flow summary
import DetailsFlujoCajaResumido from 'views/partner/reports/flujoCajaResumido/detailsFlujoCajaResumido'; // Importing details component for cash flow summary
import RecordFlujoCajaResumido from 'views/partner/reports/flujoCajaResumido/recordFlujoCajaResumido'; // Importing record component for cash flow summary
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * SummaryCashFlowView class extends JetView to create a view for cash flow summary.
 */
export default class SummaryCashFlowView extends JetView {
    /**
     * Configures the UI components for the cash flow summary view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration

        const right = {
            // Right side layout configuration
            type: 'wide',
            rows: [
                PlayersView, // Players view component
                DetailsFlujoCajaResumido, // Details view component
                RecordFlujoCajaResumido, // Record view component
            ],
        };

        const toolbar = {
            // Toolbar configuration
            view: 'toolbar',
            css: 'highlighted_header header6',
            paddingX: 5,
            paddingY: 5,
            height: 40,
            cols: [
                {
                    view: 'pager', // Pager component for navigation
                    id: 'pagerA',
                    template:
                        '{common.first()}{common.prev()}&nbsp; {common.pages()}&nbsp; {common.next()}{common.last()}',
                    autosize: false,
                    height: 35,
                    size: 1000000, // Maximum number of items to display
                },
                {
                    view: 'richselect', // Dropdown for export options
                    name: 'Export',
                    id: 'Export',
                    width: 120,
                    placeholder: _('Exportar'), // Placeholder text for dropdown
                    options: [
                        { id: '1', value: 'Excel' }, // Option to export to Excel
                        { id: '2', value: 'PDF' }, // Option to export to PDF
                    ],
                    on: {
                        onChange: function (value) {
                            // Event handler for export option change
                            if (value == 1) {
                                // Excel export
                                var table = $$('CashResume'); // Reference to the cash resume table
                                for (var j = 0; j < table.config.columns.length; j++) {
                                    if (table.config.columns[j].exportType) {
                                        delete table.config.columns[j].format; // Remove format for export
                                    }
                                }
                                webix.toExcel(table, {
                                    // Export to Excel
                                    docHeader: {
                                        text:
                                            _('Descripción del reporte: Flujo Caja Resumido ') +
                                            '\n' +
                                            _('Fecha de reporte: Desde ') +
                                            $$('Datepicker').getValue().substr(0, 10) +
                                            _(' Hasta ') +
                                            $$('Datepicker').getValue().substr(12, 20) +
                                            '\n' +
                                            _(' Fecha creación del reporte: ') +
                                            webix.Date.add(new Date(), -0, 'day').getFullYear() +
                                            '-' +
                                            ('00' + (webix.Date.add(new Date(), -0, 'day').getMonth() + 1)).slice(-2) +
                                            '-' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getHours()).slice(-2) +
                                            ':' +
                                            ('00' + webix.Date.add(new Date(), -0, 'day').getMinutes()).slice(-2),
                                        textAlign: 'right',
                                    },
                                    filename:
                                        'Virtualsoft - ' +
                                        new Date()
                                            .toLocaleString('en-GB', {
                                                hour12: true,
                                            })
                                            .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                            .replace(/[\/:]/g, '_')
                                            .toUpperCase() +
                                        ' - ' +
                                        ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                        _('Flujo Caja Resumido'),
                                });
                            } else {
                                if (value == 2) {
                                    // PDF export
                                    webix.toPDF($$('CashResume'), {
                                        // Export to PDF
                                        filename:
                                            'Virtualsoft - ' +
                                            new Date()
                                                .toLocaleString('en-GB', {
                                                    hour12: true,
                                                })
                                                .replace(/^(\d{4})-(\d{2})-(\d{2})$/g, '$3/$2/$1')
                                                .replace(/[\/:]/g, '_')
                                                .toUpperCase() +
                                            ' - ' +
                                            ($$('datatable').count() > 0 ? '' : _('No hay datos - ')) +
                                            _('Flujo Caja Resumido'),
                                        autowidth: true,
                                    });
                                }
                            }
                            $$('Export').setValue(''); // Reset export selection
                        },
                    },
                },
            ],
        };

        const left = {
            // Left side layout configuration
            css: 'int-left',
            rows: [
                FilterFlujoCajaResumido, // Filter component
                { id: 'res2', view: 'resizer' }, // Resizer component
                TableFlujoCajaResumido, // Table component
                toolbar, // Toolbar component
            ],
        };

        webix.ui.fullScreen(); // Set the UI to full screen mode
        return {
            // Return the main configuration object
            id: 'a5',
            type: 'clean',
            view: 'form',
            scroll: 'y',
            rows: [
                {
                    responsive: 'a5',
                    type: 'wide',
                    cols: [
                        left, // Left side layout
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        webix.ready(function () {
            // Wait for Webix to be ready
            if (screen.width < 500) {
                // Check screen width
                $$('res2').hide(); // Hide resizer if screen is narrow
            }
        });
    }
}

// FILE DOCUMENTED
